import { useHistory, useLocation } from "react-router-dom";
import { auth } from "../firebase/firebaseConfig";
import { signOut } from "firebase/auth";
import {
  FaMoneyCheckAlt,
  FaImage,
  FaClipboardList,
  FaUsers,
  FaUser,
  FaHome,
  FaMoneyBillWave,
  FaFileInvoiceDollar,
  FaChartBar,
  FaHandHoldingUsd,
} from "react-icons/fa";
import { IoMdExit } from "react-icons/io";
import Logo from "../assets/images/logo_azul.png";

type MenuItem = {
  id: string;
  label: string;
  icon: any;
  path: string;
  exact?: boolean; // use exact pathname match instead of startsWith
};

// Menú principal (orden de uso habitual)
const mainItems: MenuItem[] = [
  { id: "resumen",       label: "Resumen",          icon: FaChartBar,          path: "/admin/resumen" },
  { id: "empleados",     label: "Empleados",        icon: FaUsers,             path: "/admin/empleados" },
  { id: "casas",         label: "Casas",            icon: FaHome,              path: "/admin/casas" },
  { id: "pagos",         label: "Pagos Empresa",    icon: FaMoneyBillWave,     path: "/admin/pagos", exact: true },
  { id: "nomina",          label: "Nómina",            icon: FaFileInvoiceDollar, path: "/admin/nomina" },
  { id: "pagospendientes", label: "Pagos Pendientes", icon: FaHandHoldingUsd,    path: "/admin/pagos-pendientes" },
  { id: "cotizaciones",    label: "Cotizaciones",      icon: FaClipboardList,     path: "/admin/cotizaciones" },
  { id: "precios",       label: "Precios",           icon: FaMoneyCheckAlt,     path: "/admin", exact: true },
  { id: "imagenes",      label: "Imágenes",          icon: FaImage,             path: "/admin/imagen" },
];

// Al final, separados, para no confundirse con los de empresa
const bottomItems: MenuItem[] = [
  { id: "casaspersonal",   label: "Casas Personal",   icon: FaHome,              path: "/admin/casas-personal" },
  { id: "pagospersonal",   label: "Pagos Personal",   icon: FaUser,              path: "/admin/pagos-personal" },
  { id: "nominapersonal",  label: "Nómina Personal",  icon: FaFileInvoiceDollar, path: "/admin/nomina-personal" },
];

export default function SiderBarComponent() {
  const history  = useHistory();
  const location = useLocation();

  const isActive = (item: MenuItem) => {
    if (item.exact) return location.pathname === item.path;
    return location.pathname.startsWith(item.path);
  };

  const logout = async () => {
    try {
      await signOut(auth);
      history.push("/login");
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  };

  const NavButton = ({ item }: { item: MenuItem }) => {
    const Icon   = item.icon;
    const active = isActive(item);
    return (
      <button
        onClick={() => history.push(item.path)}
        className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl mb-1 transition-all duration-200 text-left ${
          active
            ? "bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-lg shadow-blue-200"
            : "text-gray-500 hover:bg-gray-100 hover:text-gray-800"
        }`}
      >
        <Icon size={18} className={active ? "text-white" : "text-gray-400"} />
        <span className="text-[15px] font-semibold">{item.label}</span>
        {active && <span className="ml-auto w-1.5 h-1.5 rounded-full bg-white opacity-80" />}
      </button>
    );
  };

  return (
    <div className="flex h-screen">
      <div className="bg-white shadow-xl lg:w-[260px] w-full flex flex-col border-r border-gray-100">

        {/* Logo */}
        <div
          onClick={() => history.push("/")}
          className="flex items-center px-6 py-5 cursor-pointer border-b border-gray-100 hover:bg-gray-50 transition-colors"
        >
          <img src={Logo} alt="Gobies" className="w-[140px] object-contain" />
        </div>

        {/* User badge */}
        <div className="px-6 py-4 border-b border-gray-100">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center text-white text-sm font-bold shadow-md">
              BT
            </div>
            <div>
              <p className="text-[11px] text-gray-400 font-semibold uppercase tracking-widest">Administrador</p>
              <p className="text-[15px] text-gray-800 font-semibold">Beatriz Tavarez</p>
            </div>
          </div>
        </div>

        {/* Navigation principal */}
        <nav className="flex-1 overflow-y-auto py-3 px-3 flex flex-col">
          {/* Ítems principales */}
          <div>
            {mainItems.map((item) => <NavButton key={item.id} item={item} />)}
          </div>

          {/* Separador + Pagos Empresa al final */}
          <div className="mt-auto pt-6">
            <div className="flex items-center gap-2 px-2 mb-3">
              <div className="flex-1 h-px bg-gray-200" />
              <span className="text-[11px] text-gray-400 font-semibold uppercase tracking-widest whitespace-nowrap">
                Empresa
              </span>
              <div className="flex-1 h-px bg-gray-200" />
            </div>
            {bottomItems.map((item) => <NavButton key={item.id} item={item} />)}
          </div>
        </nav>

        {/* Logout */}
        <div className="px-3 py-3 border-t border-gray-100">
          <button
            onClick={logout}
            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-red-400 hover:bg-red-50 hover:text-red-600 transition-all duration-200"
          >
            <IoMdExit size={20} />
            <span className="text-[15px] font-semibold">Cerrar Sesión</span>
          </button>
        </div>

      </div>
    </div>
  );
}
